// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"719face9","216":"d96f19a2","782":"719face9"}[chunkId] + ".chunk.css";
};